import categoryHttp from '@/api/category/categoryHttp';

const getCategories = (context, tags) => {
  return new Promise((resolve, reject) => {
    categoryHttp.getCategories(context)
      .then(response => {
        const categories = response.body;
        resolve(categories);
      }, error => {
        reject(error);
      });
  });
};

const deleteCategory = (context, id) => {
  return new Promise((resolve, reject) => {
    categoryHttp.deleteCategory(context, id)
      .then(() => {
        resolve();
      }, error => {
        reject(error);
      });
  });
};

const createCategory = (context, category) => {
  return new Promise((resolve, reject) => {
    categoryHttp.createCategory(context, category)
      .then(response => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const updateCategory = (context, category) => {
  return new Promise((resolve, reject) => {
    categoryHttp.updateCategory(context, category)
      .then(response => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

export default {
  getCategories,
  deleteCategory,
  createCategory,
  updateCategory
};



// WEBPACK FOOTER //
// ./src/api/category/index.js